import { projectTypeToSlotKey } from '@jobos/shared';

/**
 * Phase 1: only generic project-type templates are editable in settings.
 * Carpet Cleaning (slot key 'carpet') and Equipment Rental (which maps to the
 * 'generic' slot but uses a charge-through catalog) are explicitly excluded.
 */
export function isTemplateEditable(projectType: string): boolean {
  if (projectTypeToSlotKey(projectType) === 'carpet') return false;
  if (projectType === 'Equipment Rental') return false;
  return true;
}
